<template>
  <page-header-wrapper>
    <div slot="extra">
      <a-button
        type="primary"
        v-action:add
        icon="plus"
        @click="handleAdd"
      >新建广告</a-button>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px"
              v-model="params.where.title"
              placeholder="请输入名称"
              enter-button
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <standard-form-row title="所属分类" block style="padding-bottom: 11px">
            <a-form-item>
              <a-spin tip="Loading..." :spinning="selectLoading">
                <tag-select
                  v-model="params.where.place"
                  v-if="selectList.length > 0"
                  @change="getLists()"
                >
                  <tag-select-option
                    :value="item.id"
                    :key="index"
                    v-for="(item, index) in selectList"
                  >
                    {{ item.title }}
                  </tag-select-option>
                </tag-select>
              </a-spin>
            </a-form-item>
          </standard-form-row>

          <standard-form-row title="创建日期" block>
            <a-form-item :wrapper-col="{ sm: { span: 8 }, xs: { span: 24 } }">
              <a-range-picker
                :ranges="{
                  最近七天: [moment().subtract('days', 6), moment()],
                  今天: [moment(), moment()],
                  本月: [moment(), moment().endOf('month')]
                }"
                :placeholder="['开始日期', '结束日期']"
                @change="value => handleChangeDate(value)"
                style="width: 100%"
              />
            </a-form-item>
          </standard-form-row>
          <standard-form-row title="排序" grid>
            <a-row>
              <a-col :lg="20" :md="20" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 20 }, xs: { span: 24 } }">
                  <a-radio-group v-model="orderID" @change="handleChangeOrder">
                    <a-radio-button value="id">ID</a-radio-button>
                    <a-radio-button value="order">排序</a-radio-button>
                    <a-radio-button value="hits">点击次数</a-radio-button>
                    <a-radio-button value="updated_at">修改时间</a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :lg="4" :md="4" :sm="24" :xs="24">
                <a-form-item :wrapper-col="{ sm: { span: 24 }, xs: { span: 24 } }">
                  <a-select
                    placeholder="不限"
                    v-model="orderVal"
                    style="width: 120px"
                    @change="handleChangeOrder"
                  >
                    <a-select-option value="asc">升序</a-select-option>
                    <a-select-option value="desc">降序</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </standard-form-row>
        </template>
      </a-form>
    </a-card>
    <a-card style="margin-top: 24px" :bordered="false">
      <div slot="extra" class="d-flex align-items-center">
        <table-tool-bar-list :element="element" @change="toolBarChange" @reload="getLists()" />
        <a-radio-group @change="searchChangeState" v-model="params.where.state" style="margin-left: 1rem">
          <a-radio-button value="">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>
      </div>
      <a-list
        :loading="loading"
        :data-source="list"
        :grid="{ gutter: 24, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }"
        :pagination="pagination"
        class="screenfull"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="ant-pro-pages-list-projects-card" hoverable>
            <viewer slot="cover" class="cover-pic">
              <img :src="globalUrl + item.image" />
            </viewer>
            <a-card-meta :title="item.title">
              <template slot="description">
                <span>
                  分类:
                  <a-tag color="blue" v-if="item.ad_place && item.ad_place.title">{{
                    item.ad_place.title
                  }}</a-tag>
                  <a-tag color="#f50" v-else>无分类</a-tag>
                </span>
              </template>
            </a-card-meta>
            <div class="cardItemContent">
              <span>
                排序:
                <b style="color: red">{{ item.order }}</b>
                点击次数:
                <b style="color: green">{{ item.hits }}</b>
              </span>
              <span>
                开始时间:{{ item.start_at ? moment(item.start_at * 1000).format('YYYY-MM-DD') : '无' }}
              </span>
              <span>
                结束时间:{{ item.expire_at ? moment(item.expire_at * 1000).format('YYYY-MM-DD') : '无' }}
              </span>
            </div>
            <template slot="actions">
              <a-tooltip v-action:update title="编辑" @click="() => handleEdit(item.id)">
                <a-icon type="edit" />
              </a-tooltip>
              <a-tooltip title="删除" v-action:delete>
                <a-popconfirm
                  title="确定要删除该广告吗？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="handleOnDelete(item.id)"
                >
                  <a-icon type="delete" />
                </a-popconfirm>
              </a-tooltip>
              <a-tooltip title="修改状态" v-action:state>
                <a-switch :checked="item.state === 1" @change="handleChangeState(item.id)">
                  <a-icon slot="checkedChildren" type="check" />
                  <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
              </a-tooltip>
            </template>
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, card, select } from '@/mixins' // 引入
import ModelForm from './modules/ModelForm'

import { TagSelect, StandardFormRow, TableToolBarList } from '@/components'
const TagSelectOption = TagSelect.Option

const apiList = {
    getList: '/ads',
    delete: '/ads/',
    changeState: '/ads/',
    selectList: '/ads/places/select'
}
export default {
    name: 'AdsList',
    mixins: [list, card, select], // 使用mixins
    components: {
        TagSelect,
        TagSelectOption,
        StandardFormRow,
        ModelForm,
        TableToolBarList
    },
    data () {
        return {
            apiList,
            selectList: [],
            selectLoading: false,
            params: {
                where: {
                    state: '1'
                },
                sort: {
                    order: 'asc'
                }
            }
        }
    },
    mounted () {
        this.getLists() // 获取广告列表
        this.getSelectLists({
            url: apiList.selectList
        }) // 获取广告位下拉列表
    },
    methods: {
        /**
         * 弹窗添加广告
         * ModelForm
         */
        handleAdd () {
            const that = this
            that.$dialog(
                ModelForm,
                {
                    record: {},
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                {
                    title: '创建广告',
                    width: 700,
                    centered: true,
                    okText: '提交',
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        },
        /**
         * 弹窗编辑广告
         * aid广告id
         * @params
         *
         * ModelForm
         */
        handleEdit (aid) {
            const that = this
            that.$dialog(
                ModelForm,
                {
                    aid,
                    on: {
                        ok () {
                            that.getLists()
                        }
                    }
                },
                {
                    title: '编辑广告',
                    width: 700,
                    centered: true,
                    okText: '提交',
                    cancelText: '关闭',
                    maskClosable: false
                }
            )
        }
    }
}
</script>

<style lang="less" scoped>
.cardItemContent {
    margin-top: .5rem;
    span {
        display: block;
        margin-bottom: .25rem;
        b {
            &:first-child {
                margin-right: 1rem;
            }
        }
    }
}
</style>
